<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <SalabamLoginPage :service_title="service_title" :service_name="service_name" conditions_text_bold/>
    <b-row>
      <b-col>
        <b-img :src="logo_wiaggiare" center width="600" />
      </b-col>
    </b-row>
    <b-container fluid>
      <b-row>
        <b-col>
          <p>Con Wiaggiare, creare il tuo viaggio perfetto diventa semplice, intuitivo e sorprendentemente veloce.</p>
          <p>Grazie all’integrazione dell’intelligenza artificiale, il sistema ti permette di:</p>
          <ul>
            <li>generare itinerari personalizzati in pochi secondi</li>
            <li>combinare in modo ottimale trasporti, alloggi e attività</li>
            <li>adattare ogni dettaglio alle tue preferenze e al tuo stile di viaggio</li>
          </ul>
        </b-col>
      </b-row>
      <b-row align-h="end">
        <b-col cols="auto">
          <b-button variant="primary" :to="{name: 'menu', params: { subsection_name : 'tree-convenzioni' }}">
            Altri servizi
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import SalabamLoginPage from '@/components/salabam/SalabamLoginPage'

export default {
  name: 'SalabamWiaggiare',
  data () {
    return {
        // Variabili generali
        tagline_elem : [ { text : "Wiaggiare", link : 'conv-salabam-wiaggiare' } ],

        // Nome welfarebit del servizio
        service_title : "Wiaggiare",

        // Identificativo del servizio
        service_name : "travel-loyalty",

        logo_wiaggiare: require('@/assets/logos/salabam/wiaggiare.png')
    }
  },
  components: {
    PageTagline,
    SalabamLoginPage
  }
}
</script>

<style scoped></style>